import { getProjects } from './services/api';

// Voci della sidebar per i singoli Progetti: ogni progetto compare nel menu con
// il proprio nome. L'elenco vive qui (fuori da React) perché il Layout del
// kernel non si può modificare: le pagine lo aggiornano con setProjectMenu() e
// il nostro Layout si riallinea tramite subscribeProjectMenu().
//
// L'ultimo elenco si tiene anche in localStorage: dopo un ricaricamento la
// sidebar ha subito le voci (e apre la sezione giusta) senza aspettare la rete.

const STORAGE_KEY = 'ticket.projectMenu';

let items = [];
let version = 0;
let currentUserId = null;
const listeners = new Set();

const readStored = (userId) => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    return stored && stored.userId === userId && Array.isArray(stored.items) ? stored.items : [];
  } catch (e) {
    return [];
  }
};

const writeStored = () => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ userId: currentUserId, items }));
  } catch (e) {
    // localStorage non disponibile: la sidebar si riempie comunque dopo il caricamento.
  }
};

export const setProjectMenu = (projects) => {
  // L'ordine è quello scelto dall'utente (lo decide il server); i preferiti li raggruppa la sidebar.
  items = (projects || []).map((p) => ({ id: p.id, name: p.name, icon: p.icon, favorite: Boolean(p.favorite ?? p.is_favorite) }));
  version += 1;
  writeStored();
  listeners.forEach((listener) => listener());
};

// Chiamata durante il rendering della sidebar: riporta in memoria l'ultimo
// elenco salvato per questo utente (senza notificare, siamo già in render).
export const getProjectMenu = (userId) => {
  if (userId !== undefined && userId !== currentUserId) {
    currentUserId = userId;
    items = readStored(userId);
  }
  return items;
};

export const getProjectMenuVersion = () => version;

export const subscribeProjectMenu = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Carica l'elenco una volta per utente (le pagine dei progetti lo tengono poi aggiornato).
let loadedFor = null;
export const ensureProjectMenu = (userId) => {
  if (loadedFor === userId) return;
  loadedFor = userId;
  currentUserId = userId;
  getProjects()
    .then((data) => setProjectMenu(data.projects))
    .catch(() => {
      loadedFor = null;
    });
};
